import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from './components/components.module';
import { RouterModule } from '@angular/router';
import { BuiltInModule } from './built-in/built-in.module';
import { HttpClientModule } from '@angular/common/http';
import { PipesModule } from './pipes/pipes.module';
import { DragDropListModule } from 'ng-drag-drop-list';
import { DirectivesModule } from './directives/directives.module';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ClubprogramReportsModule } from './clubprogram-reports/clubprogram-reports.module';

@NgModule({
  imports: [
    CommonModule,

    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#4b80e0',
      innerStrokeColor: '#4b80e0',
      animationDuration: 300,
    })
  ],
  declarations: [],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    RouterModule,
    BuiltInModule,
    HttpClientModule,
    PipesModule,
    DragDropListModule,
    DirectivesModule,
    NgCircleProgressModule,
    ClubprogramReportsModule,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts